import Buttons from '@klv/molecules/buttons';
import FadeInUp from '@klv/utils/fade-in-up';
import Typography from '@klv/atoms/typography';
import { SingleLineForm } from '@klv/atoms/single-line-form';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/homepageHero.module.css';
import type { IHomepageHero } from './types';

const HomepageHero = ({
  backgroundColor,
  customPadding: { customPaddingBottom = 'default', customPaddingTop = 'default' },
  ctaContent,
  heroContent,
}: IHomepageHero) => (
  <div data-organism="Homepage Hero" className={generateClassName([
    styles.heroWrapper,
    styles[backgroundColor],
    customPaddingTop + 'PaddingTop',
    customPaddingBottom + 'PaddingBottom',
  ])}>
    <div className={'grid'}>
      <div className={styles.heroIcon}>
        <svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 20.1084H0V0.108398H30L23.7028 10.1084L30 20.1084Z" fill="url(#styledHeroFlagIcon)"/>
          <defs>
            <linearGradient id="styledHeroFlagIcon" x1="32" y1="1.49951" x2="-4.5" y2="23.9995" gradientUnits="userSpaceOnUse">
              <stop stopColor="#ED7598"/>
              <stop offset="0.456219" stopColor="#F75650"/>
              <stop offset="1" stopColor="#FFA661"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      {heroContent?.gradientHeadline?.headline && (
        // no forwardedAs. Stakeholders want the h1 to be in content cta
        <Typography
          className={generateClassName([styles.headline, styles.fadeInUp])}
          variant='display3'
          dangerouslySetInnerHTML={{ __html: heroContent.gradientHeadline.headline }}
        />
      )}
      {heroContent?.subheader && (
        <Typography
          className={generateClassName([styles.subheader, styles.fadeInUp])}
          variant='paragraph2'
          dangerouslySetInnerHTML={{ __html: heroContent.subheader }}
        />
      )} 
      {heroContent?.buttons && !heroContent?.showSingleLineForm && (  
        <Buttons
          className={generateClassName([styles.buttons, styles.fadeInUp])}
          buttonColor={backgroundColor === 'light' ? 'dark' : 'light'}
          variants={['primary', 'ghost']}
          buttons={heroContent.buttons}
        />
      )}
      {
        heroContent?.showSingleLineForm && (
          <div className={generateClassName([styles.singleLineForm, styles.fadeInUp])}>
            <SingleLineForm
              backgroundColor={backgroundColor}
              primaryButtonText={heroContent?.singleLineForm?.primaryButtonText}
              buttons={heroContent?.buttons}
              placeholderText={heroContent?.singleLineForm?.placeholderText}
            />
          </div>
        )
      }
    </div>
    <div className={generateClassName([styles.image, styles.fadeInUp])}
      style={heroContent?.image?.publicUrl ? { backgroundImage: `url(${heroContent?.image?.publicUrl})` } : {}}
    />
    <div className={'grid'}>
    <div className={styles.cta}>
      {ctaContent.headline && (
        <FadeInUp>
          <h1 className={styles.message}>{ctaContent.headline}</h1>
        </FadeInUp>
      )}
      {ctaContent.buttons && (
        <div className={styles.ctaButtons}>
          <Buttons
            buttonColor={backgroundColor === 'light' ? 'dark' : 'light'}
            variants={['ghost']}
            buttons={ctaContent.buttons}
          />
        </div>)
      }
      </div>
    </div>
  </div>
);

export default HomepageHero;
